module.exports = __webpack_public_path__ + "static/sparkle_logo_white-1c6a7b75f399e53f0fb6f0f4217540ef.png";